import FileUploader from "../../components/FileUploader";
import React, { useEffect, useState } from 'react';
import { useAxios } from '../../utils/useAxios';  // importo il tuo hook axios
import { useRoleDesc } from "../../utils/useRoleDesc";
import { useHistory } from "react-router";
import { CircularProgress } from '@mui/material';


const UploadManage = () => {
    const [uploadErrors, setUploadErrors] = useState([]);
    const [downloading, setDownloading] = useState(false);
    const axios = useAxios();
    const whichRole = useRoleDesc();
    const history = useHistory();

    const handleUpload = (files) => {
        setUploadErrors([]);
        const errors = [];
        files.forEach((file) => {
            if (file.size > 5 * 1024 * 1024) {
                errors.push(`Il file "${file.name}" è troppo grande (max 5MB).`);
            }
        });
        if (errors.length > 0) {
            setUploadErrors(errors);
        } else {

        }
    };

    // Funzione per scaricare i documenti
    const handleDownload = async () => {
        setDownloading(true);
        try {
            const response = await axios.get('clouddataupdate/DownloadDocuments', {
                responseType: 'blob',  // importante per gestire il file binario
            });

            // Creo un link temporaneo per scaricare il file
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'akonfig-files.zip'); // nome file suggerito
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            alert("Errore durante il download dei documenti. Riprova.");
        } finally {
            setDownloading(false);
        }
    };


    useEffect(() => {


        if (whichRole !== "Admin" && whichRole !== "VIP") {
            history.push('/home');


        }

    }, []);

    return (
        <div style={styles.pageContainer}>
            {/* Pulsante per scaricare i documenti */}
            <div style={{ textAlign: 'center', position: 'absolute', top: '120px', right: '40px' }}>
                <button
                    onClick={handleDownload}
                    disabled={downloading}
                    style={{
                        padding: '12px 40px',
                        backgroundColor: downloading ? '#66b366' : 'green',
                        color: '#fff',
                        border: 'none',
                        borderRadius: 6,
                        fontSize: 16,
                        cursor: downloading ? 'not-allowed' : 'pointer',
                        fontWeight: '600',
                        boxShadow: '0 3px 6px rgba(0,0,0,0.1)',
                        userSelect: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px',
                    }}
                >
                    {downloading && (
                        <CircularProgress
                            size={16}
                            sx={{ color: '#fff' }}
                        />
                    )}
                    {downloading ? 'Downloading...' : 'Download files'}
                </button>
            </div>
            <header style={styles.header}>
                <h1 style={styles.title}>Upload your files</h1>
                <p style={styles.description}>
                    Select one or more files from your device to upload to the system.
                    You can upload XLSX files.
                </p>
            </header>

            <main style={styles.mainContent}>
                <FileUploader onFilesSelected={handleUpload} />

                {/* {uploadErrors.length > 0 && (
                    <section style={styles.errorSection}>
                        <h3 style={styles.errorTitle}>Errori durante l'upload:</h3>
                        <ul style={styles.errorList}>
                            {uploadErrors.map((err, idx) => (
                                <li key={idx} style={styles.errorItem}>{err}</li>
                            ))}
                        </ul>
                    </section>
                )} */}


            </main>
        </div>
    );
};

const styles = {
    pageContainer: {
        maxWidth: 900,
        margin: "40px auto",
        padding: "0 20px",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        color: "#333",
        lineHeight: 1.6,
    },
    header: {
        marginBottom: 30,
        textAlign: "center",
    },
    title: {
        fontSize: 32,
        fontWeight: "700",
        marginBottom: 10,
        color: "#2c3e50",
    },
    description: {
        fontSize: 18,
        color: "#555",
        maxWidth: 600,
        margin: "0 auto",
    },
    mainContent: {
        backgroundColor: "white",
        padding: 30,
        borderRadius: 10,
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    },
    errorSection: {
        marginTop: 25,
        backgroundColor: "#ffe6e6",
        padding: 15,
        borderRadius: 6,
        border: "1px solid #ff4d4d",
    },
    errorTitle: {
        color: "#d8000c",
        marginBottom: 10,
    },
    errorList: {
        listStyleType: "disc",
        paddingLeft: 20,
        margin: 0,
    },
    errorItem: {
        marginBottom: 6,
        color: "#b30000",
        fontWeight: "600",
    },
};

export default UploadManage;
